/**
 * Klug Toys - Subcategory Navigation Web Component
 */
if (!customElements.get('subcategory-navigation')) {
  class SubcategoryNavigation extends HTMLElement {
    constructor() {
      super();
      this.track = null;
      this.handleKeyDown = this.handleKeyDown.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
    }

    connectedCallback() {
      this.track = this.querySelector('.subcategory-nav__track');
      if (!this.track) return;

      this.track.addEventListener('keydown', this.handleKeyDown);

      // Scroll active pill into view if needed
      requestAnimationFrame(() => {
        this.scrollToActive();
      });

      // Listen for Shopify theme editor events
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
    }

    disconnectedCallback() {
      if (this.track) {
        this.track.removeEventListener('keydown', this.handleKeyDown);
      }
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }

    scrollToActive() {
      if (!this.track) return;
      const activePill = this.track.querySelector('.subcategory-pill--active');
      if (activePill) {
        const trackRect = this.track.getBoundingClientRect();
        const pillRect = activePill.getBoundingClientRect();

        // If pill is outside visible track bounds, scroll it into view
        if (pillRect.left < trackRect.left || pillRect.right > trackRect.right) {
          activePill.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }
      }
    }

    handleKeyDown(event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

      const pills = Array.from(this.track.querySelectorAll('a.subcategory-pill, button.subcategory-pill'));
      const currentIndex = pills.indexOf(document.activeElement);

      if (currentIndex === -1) return;

      let nextIndex = currentIndex;
      if (event.key === 'ArrowRight') {
        nextIndex = (currentIndex + 1) % pills.length;
      } else if (event.key === 'ArrowLeft') {
        nextIndex = (currentIndex - 1 + pills.length) % pills.length;
      }

      const nextPill = pills[nextIndex];
      if (nextPill) {
        event.preventDefault();
        nextPill.focus();
        nextPill.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });
      }
    }

    handleBlockSelect(event) {
      if (!this.contains(event.target)) return;
      const pill = event.target.querySelector('.subcategory-pill');
      if (pill) {
        pill.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }
  }

  customElements.define('subcategory-navigation', SubcategoryNavigation);
}
